export function MarketplaceIcon({ size = 18 }: { size?: number } = {}) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} stroke="currentColor" fill="none" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M6 2L3 7v13a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V7l-3-5z"/>
      <line x1="3" y1="7" x2="21" y2="7"/>
      <path d="M16 11a4 4 0 0 1-8 0"/>
    </svg>
  )
}
